// Moved to @livingsyncs/ui (frontend split epic, Phase 2 Task 2.4). Shim kept
// so nothing importing the old path breaks during the transition.
// Real function declarations, not reference copies — see hooks/useAuth.ts.
import * as _module from "@livingsyncs/ui";

export function createAppQueryCache() {
  return _module.createAppQueryCache();
}
export function notifyQueryError(
  ...args: Parameters<typeof _module.notifyQueryError>
) {
  return _module.notifyQueryError(...args);
}
export function __resetErrorToastDedupeForTests(): void {
  return _module.__resetErrorToastDedupeForTests();
}
